import React, { useEffect, useState } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const sources = ['https://tile.openstreetmap.de/{z}/{x}/{y}.png', 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'];
const vietnamBounds = [[8.3, 102], [23.6, 110.5]];
const marker = L.divIcon({ className: 'location-picker-marker-wrap', html: '<span class="location-picker-marker"></span>', iconSize: [18, 18], iconAnchor: [9, 9] });
function MapPosition({ latitude, longitude, onPick, focusVersion }) {
  const map = useMap();
  useMapEvents({ click: ({ latlng }) => onPick(latlng.lat, latlng.lng) });
  useEffect(() => {
    if (latitude != null && longitude != null) map.setView([latitude, longitude], Math.max(map.getZoom(), 16), { animate: false });
  }, [map, latitude, longitude, focusVersion]);
  useEffect(() => {
    const updateSize = () => map.invalidateSize({ pan: false });
    const frame = requestAnimationFrame(updateSize);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateSize) : null;
    observer?.observe(map.getContainer());
    window.addEventListener('resize', updateSize);
    return () => { cancelAnimationFrame(frame); observer?.disconnect(); window.removeEventListener('resize', updateSize); };
  }, [map]);
  return null;
}
export default function ProjectLocationMap({ latitude, longitude, disabled, onPick, en, focusVersion = 0 }) {
  const [source, setSource] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const hasCoordinates = latitude != null && longitude != null;
  const pick = (lat, lng) => {
    if (!disabled && lat >= 8.3 && lat <= 23.6 && lng >= 102 && lng <= 110.5) onPick(lat, lng);
  };
  return <div className="location-picker-shell">
    {source >= sources.length && <div role="status" className="project-map-error">
      <span>{en ? 'Unable to load the map background. Your coordinates are retained.' : 'Chưa tải được nền bản đồ. Tọa độ đã nhập vẫn được giữ lại.'}</span>
      <button type="button" className="btn btn-neutral btn-sm" onClick={() => { setAttempt((value) => value + 1); setSource(0); }}>{en ? 'Reload map' : 'Tải lại bản đồ'}</button>
    </div>}
    <MapContainer className="location-picker-map project-location-map" center={hasCoordinates ? [latitude, longitude] : [10.8231, 106.6297]} zoom={hasCoordinates ? 16 : 13} scrollWheelZoom maxBounds={vietnamBounds} maxBoundsViscosity={1.0} minZoom={5} maxZoom={18} worldCopyJump={false}>
      {source < sources.length && <TileLayer key={`${source}-${attempt}`} url={sources[source]} maxZoom={18} attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' eventHandlers={{ tileerror: () => setSource((current) => current === source ? current + 1 : current) }} />}
      <MapPosition latitude={latitude} longitude={longitude} onPick={pick} focusVersion={focusVersion} />
      {hasCoordinates && <Marker position={[latitude, longitude]} icon={marker} draggable={!disabled} eventHandlers={{ dragend: (event) => { const position = event.target.getLatLng(); pick(position.lat, position.lng); } }} />}
    </MapContainer>
    <p className="location-picker-note">{en ? 'Click directly on the map to place a pin. Drag the pin to adjust to an exact position.' : 'Bấm trực tiếp lên bản đồ để đặt pin. Kéo pin để chỉnh lại vị trí chính xác hơn.'}</p>
    <div className="location-picker-coordinates"><span>{en ? 'Latitude' : 'Vĩ độ'}: {latitude ?? (en ? 'Not selected' : 'Chưa chọn')}</span><span>{en ? 'Longitude' : 'Kinh độ'}: {longitude ?? (en ? 'Not selected' : 'Chưa chọn')}</span></div>
  </div>;
}
